import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { PaymentBalanceDueCard } from '../payments/PaymentBalanceDueCard';

interface BalanceDueCardProps {
  balanceDue: number;
  accountCredit?: number;
  propertyName: string;
  unitName: string;
  autopayEnabled?: boolean;
  onMakePayment: () => void;
  style?: StyleProp<ViewStyle>;
}

/**
 * Home screen balance due card.
 * Thin wrapper around the unified PaymentBalanceDueCard with variant='compact'.
 */
export const BalanceDueCard: React.FC<BalanceDueCardProps> = React.memo(({
  balanceDue,
  accountCredit,
  propertyName,
  unitName,
  autopayEnabled,
  onMakePayment,
  style,
}) => (
  <PaymentBalanceDueCard
    balanceDue={balanceDue}
    accountCredit={accountCredit}
    variant="compact"
    autopayEnabled={autopayEnabled}
    propertyName={propertyName}
    unitName={unitName}
    onMakePayment={onMakePayment}
    style={style}
  />
));

BalanceDueCard.displayName = 'BalanceDueCard';
